export class ZeroEtlRoutingPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "routingMode",
            "baseName": "routingMode",
            "type": "ZeroEtlRoutingMode",
            "format": ""
        },
        {
            "name": "namespaceTemplate",
            "baseName": "namespaceTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableTemplate",
            "baseName": "tableTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "identityColumns",
            "baseName": "identityColumns",
            "type": "Array<ZeroEtlIdentityColumnSpec>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlRoutingPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
